const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE4IDQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggdHJhbnNmb3JtPSJyb3RhdGUoOTApIHRyYW5zbGF0ZSgtMC41IC0xNy41KSIgZD0iTTEgMy41YTEuNSAxLjUgMCAxIDEgMyAwIDEuNSAxLjUgMCAwIDEtMyAwem0wIDUuMjVhMS41IDEuNSAwIDEgMSAzIDAgMS41IDEuNSAwIDAgMS0zIDB6TTEgMTRhMS41IDEuNSAwIDEgMSAzIDAgMS41IDEuNSAwIDAgMS0zIDB6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=ellipsis-81f5bc2a.mjs.map
